import React from "react";
import "../../assets/css/slider.css"; // Custom styling
import PdfViewer from "../../components/PdfViewer";

const CourtyardBrochure = () => {
    return (
        <div className="slider-container">
            {/* <PdfViewer fileUrl="/Courtyard/brochure/Payment_Plan.pdf" /> */}
            {/* <PdfViewer fileUrl="https://www.orimi.com/pdf-test.pdf" /> */}
            <iframe widdth="100%" height="100vh" src="/Courtyard/brochure/brochure.pdf" style={{ width: "100vw", height: "100vh" }} />
        </div>
    )
}

export default CourtyardBrochure;